// eslint-disable react-hooks/exhaustive-deps
import React, { useState, useEffect } from 'react';
import { Typography } from '@scale/scaleui';
import { IUserDetail } from 'react-scale/components/WebinarSessions/types';
import { lookupUserIdsOrEmails } from '../api';

interface IRsvpUsersProps {
  userIds: string[];
}

export const RsvpUsers: React.FC<IRsvpUsersProps> = ({ userIds }) => {
  const [users, setUsers] = useState<IUserDetail[]>([]);
  useEffect(() => {
    if (userIds?.length) {
      (async () => {
        const users = await lookupUserIdsOrEmails(userIds);
        setUsers(users);
      })();
    }
  }, [userIds]);

  return (
    <>
      <div className="flex gap-1 items-center mb-1">
        <Typography.Subtitle3 className="text-neutral-600">RSVP'd User(s)</Typography.Subtitle3>
      </div>
      <div className="flex flex-col max-h-[108px] overflow-y-auto overflow-x-hidden relative">
        {users.map((user: IUserDetail) => (
          <div key={user.id} className="flex gap-1 items-center">
            <Typography.Paragraph3>
              • {user.email}
              {user.name ? ` (${user.name})` : ''}
            </Typography.Paragraph3>
          </div>
        ))}
      </div>
    </>
  );
};
